import React from "react"

const Descending = props => {
  return (
    <svg
      height='17'
      width='16'
      fill='none'
      viewBox='0 0 16 17'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.1112 4.5402L5.59757 10.0539L5.55681 7.89355L4.38587 7.87145L4.43964 11.4494L4.46444 12.0355L5.05099 12.0599L8.62851 12.1141L8.60642 10.9432L6.4465 10.902L11.9598 5.38872L11.1112 4.5402Z'
        fill='#131212'
      />
    </svg>
  )
}

export default Descending
